export interface CandidateComment {
	id: string;
	candidate_id: string;
	created_at: string;
	updated_at: string;
	content: string;
	created_by: string;
	created_by_uuid: string | null;
	migration?: boolean;
	profiles?: {
		first_name: string | null;
		last_name: string | null;
	};
}

// Type for the values stored in the custom_fields column
export type CandidateCustomFieldsValues = Record<string, any>;

export interface Candidate {
  id: string;
  name: string;
  email: string;
  phone?: string;
  function?: string;
  skills?: string[];
  match_score?: number;
  created_at?: string;
  updated_at?: string;
  manager?: string;
  status?: string;
  unavailable_until?: string | null;
  ai_analysis?: any;
  ai_science_analysis?: any;
  ai_synthesis?: string;
  embedding?: any;
  linkedin?: string;
  linkedin_json?: any;
  location?: string;
  default_resume?: string | null;
  custom_fields?: CandidateCustomFieldsValues;
}

// Language proficiency levels (CEFR scale)
export type CEFRLevel = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export interface CandidateLanguage {
  id: string;
  candidate_id: string;
  language: string; // canonical English name
  language_code: string; // ISO 639-1 code
  cefr_level: CEFRLevel;
  raw_term?: string; // original CV text
  is_user_owned: boolean;
  created_at: string;
}

export interface JobLanguage {
  id: string;
  job_id: string;
  language: string; // canonical English name
  language_code: string; // ISO 639-1 code
  min_cefr_level: CEFRLevel;
  is_mandatory: boolean;
  raw_term?: string; // original job text
  is_user_owned: boolean;
  created_at: string;
}

// CEFR level labels
export const CEFR_LEVELS = {
  0: 'Unknown',
  1: 'A1 - Beginner',
  2: 'A2 - Elementary',
  3: 'B1 - Intermediate',
  4: 'B2 - Upper Intermediate',
  5: 'C1 - Advanced',
  6: 'C2 - Proficient',
  7: 'Native'
} as const;

// Common languages with their ISO 639-1 codes
export const COMMON_LANGUAGES = {
  'en': 'English',
  'fr': 'French',
  'nl': 'Dutch',
  'de': 'German',
  'es': 'Spanish',
  'it': 'Italian',
  'pt': 'Portuguese',
  'pl': 'Polish',
  'sv': 'Swedish',
  'da': 'Danish',
  'fi': 'Finnish',
  'no': 'Norwegian',
  'cs': 'Czech',
  'hu': 'Hungarian',
  'ro': 'Romanian',
  'ru': 'Russian',
  'ar': 'Arabic',
  'zh': 'Chinese',
  'ja': 'Japanese'
} as const;
